var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAk064343430(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 174.2 30",
    style: {
      enableBackground: "new 0 0 174.2 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 31.2,
    y: 7,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 1.7789 22.2548)",
    width: 28.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.6,
    y: 7.1,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 4.1874 49.922)",
    width: 1.2,
    height: 28.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.7,
    y: 11,
    width: 3.6,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,30H28.8V0H59V30z M30,28.8h27.8V1.2H30V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,25.9H32.3V3.7H55V25.9z M33.4,24.8h20.5v-20H33.4V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.4,
    y: 7,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 15.3303 76.4737)",
    width: 28.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.9,
    y: 7.1,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 62.0744 149.88)",
    width: 1.2,
    height: 28.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 11,
    width: 3.6,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.2,30h-30.1V0h30.1V30z M145.2,28.8h27.8V1.2h-27.8V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.3,25.9h-22.8V3.7h22.8V25.9z M148.7,24.8h20.5v-20h-20.5V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.7,
    y: 7,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 11.9552 62.9699)",
    width: 28.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.2,
    y: 7.1,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 47.6549 124.9807)",
    width: 1.2,
    height: 28.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.5,30h-30.1V0h30.1V30z M116.5,28.8h27.8V1.2h-27.8V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.6,25.9h-22.8V3.7h22.8V25.9z M120,24.8h20.5v-20H120V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.7,
    y: 7,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 8.5461 49.3303)",
    width: 28.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.2,
    y: 7.1,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 33.0961 99.841)",
    width: 1.2,
    height: 28.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.3,
    y: 11,
    width: 3.6,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.5,30H86.4V0h30.1V30z M87.6,28.8h27.8V1.2H87.6V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.6,25.9H89.8V3.7h22.8V25.9z M91,24.8h20.5v-20H91V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 7,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 5.171 35.8265)",
    width: 28.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.5,
    y: 7.1,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 18.6763 74.9414)",
    width: 1.2,
    height: 28.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8,30H57.7V0h30.1V30z M58.8,28.8h27.8V1.2H58.8V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9,25.9H61.1V3.7h22.8V25.9z M62.3,24.8h20.5v-20H62.3V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.3,
    y: 7,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 -1.6132 8.683)",
    width: 28.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.8,
    y: 7.1,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 -10.3015 24.9026)",
    width: 1.2,
    height: 28.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1,30H0V0h30.1V30z M1.2,28.8H29V1.2H1.2V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2,25.9H3.4V3.7h22.8V25.9z M4.6,24.8H25v-20H4.6V24.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAk064343430);
export default __webpack_public_path__ + "static/media/AK0_6_434343_0.07ec8ae3876a41db711ad5c7f78eb47f.svg";
export { ForwardRef as ReactComponent };